/**
 * Device Guide JavaScript
 * File: device-guide.js
 * Location: assets/device-guide.js
 */

(function() {
  'use strict';

  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initTabNavigation();
    initCarousel();
    initVideoPlayer();
  }

  /**
   * Tab Navigation
   */
  function initTabNavigation() {
    const navItems = document.querySelectorAll('.nav-item');
    const contentSections = document.querySelectorAll('.content-section');

    if (!navItems.length || !contentSections.length) return;

    navItems.forEach(function(navItem) {
      navItem.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        
        // Remove active class from all nav items
        navItems.forEach(function(item) {
          item.classList.remove('active');
        });
        
        // Add active class to clicked nav item
        this.classList.add('active');
        
        // Hide all content sections
        contentSections.forEach(function(section) {
          section.classList.remove('active');
        });
        
        // Show target content section
        const targetSection = document.getElementById(targetTab);
        if (targetSection) {
          targetSection.classList.add('active');
          
          // Scroll to top of content
          const mainContent = document.querySelector('.device-guide-content');
          if (mainContent) {
            mainContent.scrollTop = 0;
          }
          
          // On mobile, scroll to the content area smoothly
          if (window.innerWidth <= 1024) {
            const contentArea = document.querySelector('.device-guide-content');
            if (contentArea) {
              // Small delay to ensure content is rendered and active class is applied
              setTimeout(function() {
                contentArea.scrollIntoView({ 
                  behavior: 'smooth', 
                  block: 'start' 
                });
              }, 100);
            }
          }
          
          // Reset carousel if switching to quick-start
          if (targetTab === 'quick-start') {
            resetCarousel();
          }
        }
      });
    });

    // Set initial active tab
    if (navItems[0]) {
      navItems[0].classList.add('active');
    }
    if (contentSections[0]) {
      contentSections[0].classList.add('active');
    }
  }

  /**
   * Carousel Functionality
   */
  function initCarousel() {
    const carouselTrack = document.querySelector('.carousel-track');
    const slides = document.querySelectorAll('.carousel-slide');
    const prevBtn = document.querySelector('.carousel-prev');
    const nextBtn = document.querySelector('.carousel-next');
    const currentStepDisplay = document.querySelector('.current-step');
    const totalStepsDisplay = document.querySelector('.total-steps');

    if (!carouselTrack || !slides.length) return;

    let currentIndex = 0;
    const totalSlides = slides.length;

    // Set total steps
    if (totalStepsDisplay) {
      totalStepsDisplay.textContent = totalSlides;
    }

    function updateCarousel() {
      // Move carousel
      const offset = -currentIndex * 100;
      carouselTrack.style.transform = 'translateX(' + offset + '%)';

      // Update active slide
      slides.forEach(function(slide, index) {
        if (index === currentIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });

      // Update step counter
      if (currentStepDisplay) {
        currentStepDisplay.textContent = currentIndex + 1;
      }

      // Update button states
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === totalSlides - 1;
      }
    }

    function goToSlide(index) {
      if (index < 0 || index >= totalSlides) return;
      currentIndex = index;
      updateCarousel();
    }

    function nextSlide() {
      if (currentIndex < totalSlides - 1) {
        goToSlide(currentIndex + 1);
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        goToSlide(currentIndex - 1);
      }
    }

    // Event listeners
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      const carouselWrapper = document.querySelector('.carousel-wrapper');
      if (!carouselWrapper) return;
      
      // Only navigate if carousel is visible
      const quickStartSection = document.getElementById('quick-start');
      if (!quickStartSection || !quickStartSection.classList.contains('active')) {
        return;
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    carouselTrack.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carouselTrack.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swiped left - go to next
          nextSlide();
        } else {
          // Swiped right - go to previous
          prevSlide();
        }
      }
    }

    // Initialize
    updateCarousel();
  }

  function resetCarousel() {
    const carouselTrack = document.querySelector('.carousel-track');
    const currentStepDisplay = document.querySelector('.current-step');
    
    if (carouselTrack) {
      carouselTrack.style.transform = 'translateX(0%)';
    }
    if (currentStepDisplay) {
      currentStepDisplay.textContent = '1';
    }
    
    // Re-initialize carousel to reset state
    initCarousel();
  }

  /**
   * Video Player
   */
  function initVideoPlayer() {
    const videoWrapper = document.querySelector('.video-wrapper');
    const playButton = document.querySelector('.play-button');

    if (!videoWrapper || !playButton) return;

    playButton.addEventListener('click', function(e) {
      e.stopPropagation();
      handleVideoPlay();
    });

    videoWrapper.addEventListener('click', function() {
      handleVideoPlay();
    });

    function handleVideoPlay() {
      const videoUrl = videoWrapper.getAttribute('data-video-url');
      
      if (!videoUrl) {
        console.log('No video URL provided');
        return;
      }

      // Check if it's a Shopify CDN video or direct video file
      if (videoUrl.includes('shopify.com') || videoUrl.includes('.mp4') || videoUrl.includes('.webm')) {
        // It's a direct video file - create HTML5 video element
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.muted = true;  // Start muted
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        
        // Replace the thumbnail with the video
        videoWrapper.innerHTML = '';
        videoWrapper.appendChild(video);
        
      } else if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        // It's a YouTube video
        let videoId = '';
        
        if (videoUrl.includes('youtu.be/')) {
          videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
        } else if (videoUrl.includes('watch?v=')) {
          videoId = videoUrl.split('watch?v=')[1].split('&')[0];
        } else if (videoUrl.includes('embed/')) {
          videoId = videoUrl.split('embed/')[1].split('?')[0];
        }
        
        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
          iframe.style.borderRadius = '12px';
          
          videoWrapper.innerHTML = '';
          videoWrapper.appendChild(iframe);
        }
        
      } else if (videoUrl.includes('vimeo.com')) {
        // It's a Vimeo video
        let videoId = videoUrl.split('vimeo.com/')[1].split('?')[0].split('/').pop();
        
        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&muted=1';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.style.border = 'none';
          iframe.style.borderRadius = '12px';
          
          videoWrapper.innerHTML = '';
          videoWrapper.appendChild(iframe);
        }
        
      } else {
        // Unknown format - open in new tab as fallback
        window.open(videoUrl, '_blank');
      }
    }
  }

  /**
   * Smooth Scroll for Anchor Links
   */
  function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /**
   * Mobile Menu Toggle (if needed)
   */
  function initMobileMenu() {
    // Check if we're on mobile
    function isMobile() {
      return window.innerWidth <= 1024;
    }

    if (!isMobile()) return;

    const sidebar = document.querySelector('.device-guide-sidebar');
    const navItems = document.querySelectorAll('.nav-item');

    if (!sidebar) return;

    // On mobile, collapse sidebar after selecting an item
    navItems.forEach(function(item) {
      item.addEventListener('click', function() {
        if (isMobile()) {
          // Optional: Add collapse functionality if needed
          // For now, we'll just scroll to content
          window.scrollTo({
            top: sidebar.offsetHeight,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /**
   * Lazy Load Images (Performance optimization)
   */
  function initLazyLoading() {
    // Check if browser supports IntersectionObserver
    if ('IntersectionObserver' in window) {
      const images = document.querySelectorAll('img[data-src]');
      
      const imageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
            imageObserver.unobserve(img);
          }
        });
      });

      images.forEach(function(img) {
        imageObserver.observe(img);
      });
    }
  }

  /**
   * Track User Interactions (Optional - for analytics)
   */
  function trackInteraction(action, label) {
    // If you're using Google Analytics or similar
    if (typeof gtag !== 'undefined') {
      gtag('event', action, {
        'event_category': 'Device Guide',
        'event_label': label
      });
    }
    
    // Or use Shopify Analytics
    if (typeof ShopifyAnalytics !== 'undefined') {
      ShopifyAnalytics.lib.track('Device Guide Interaction', {
        action: action,
        label: label
      });
    }
  }

  // Initialize optional features
  initSmoothScroll();
  initMobileMenu();
  initLazyLoading();

  // Export functions for external use if needed
  window.DeviceGuide = {
    goToTab: function(tabId) {
      const navItem = document.querySelector('[data-tab="' + tabId + '"]');
      if (navItem) {
        navItem.click();
      }
    },
    resetCarousel: resetCarousel
  };

})();